import type { HelpFile } from '../../types/help'
import { AutoAssignRulesTestIds } from '../../../testids/AutoAssignRulesTestIds'

export const autoAssignRulesHelp: HelpFile = {
  docPage: '/docs/governance/auto-assign-rules',
  texts: {
    [AutoAssignRulesTestIds.autoAssignRulesPage]:
      'Liste der Auto-Assign-Regeln, die Identitäten, die einer Bedingung entsprechen, automatisch Zugriffsprofile gewähren.',
    [AutoAssignRulesTestIds.btnExecutionHistory]:
      'Öffnet die Ausführungshistorie mit jedem Evaluierungslauf, den betroffenen Identitäten und etwaigen Fehlern.',
    [AutoAssignRulesTestIds.colName]: null,
    [AutoAssignRulesTestIds.colOwner]:
      'Partei, die die Regel besitzt und für die Korrektheit ihrer Bedingung verantwortlich ist.',
    [AutoAssignRulesTestIds.colPriority]:
      'Priorität, die als Tie-Breaker dient, wenn mehrere Regeln dasselbe Zugriffsprofil gewähren.',
    [AutoAssignRulesTestIds.colType]:
      'Ob die Regel direkt Zugriffsprofile oder eine Funktionsgruppe gewährt, die mehrere Zugriffsprofile bündelt.',
    [AutoAssignRulesTestIds.colTarget]:
      'Was die Regel beim Zutreffen ihrer Bedingung gewährt — entweder eine Anzahl von Zugriffsprofilen oder den Namen einer Funktionsgruppe.',
    [AutoAssignRulesTestIds.colRisk]:
      'Risikostufe des sensibelsten Zugriffsprofils, das diese Regel gewährt.',
    [AutoAssignRulesTestIds.colStatus]:
      'Ob die Regel aktiv, pausiert oder im Entwurf ist.',
  },
}
